import React from "react";
import {cx} from "../../../lib/ClassSet";
import StatusTag from "../../../components/StatusTag";
import {statusColor, statusLabel, waitingFor} from "../statusDisplay";
import {shortenDate} from "../../stockTransfers/statusDisplay";

const ClientDispatchItem = (props) => {
  const {data} = props;
  const status = data.get("status");

  const classes = cx({
    "item": true,
    "client-dispatch-list-item": true,
    "u-selected": props.selected,
    "u-cancelled": status === "cancelled",
    "u-completed": status === "shipped",
  });

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field f-id">{data.get("id")}</td>
      <td className="field">{data.get("partnerName")}</td>
      <td className="field">{data.get("reference")}</td>
      <td className="field f-warehouse">{data.get("originWarehouseId")}</td>
      <td className="field f-date">{shortenDate(data.get("dispatchDate"))}</td>
      <td className="field f-quantity">{data.get("totalQuantity")}</td>
      <td className="field f-status">
        <StatusTag color={statusColor(status)} text={statusLabel(status)} noMargin />
        {status === "draft" && data.get("stordOrderNumber") &&
          <React.Fragment>
            {" "}
            <StatusTag color={StatusTag.COLORS.BLUE} text="Stord" noMargin title={waitingFor(data)} />
          </React.Fragment>}
        {status === "shipped" && data.get("serialsPending") > 0 &&
          <React.Fragment>
            {" "}
            <StatusTag color={StatusTag.COLORS.ORANGE} text="serials" noMargin title={waitingFor(data)} />
          </React.Fragment>}
      </td>
    </tr>
  )
}

export default ClientDispatchItem;
